import { Link } from 'react-router-dom';
import ResqlyMark from './ResqlyMark';

/**
 * Ranger / provider authentication — separate from customer login.
 */
export default function RangerAuthLayout({ children, footer }) {
  return (
    <div className="resqly-shell min-h-screen min-h-[100dvh]">
      <div className="resqly-frame flex flex-col min-h-screen min-h-[100dvh]">
        <div className="auth-hero relative px-6 pt-12 pb-10 text-white overflow-hidden">
          <div className="auth-hero-glow absolute -right-16 -top-16 h-48 w-48 rounded-full bg-white/10" />
          <div className="relative z-10 flex flex-col items-center text-center">
            <ResqlyMark size={48} className="drop-shadow-[0_8px_24px_rgba(0,0,0,0.2)] opacity-95" />
            <h1 className="mt-4 text-xl font-bold tracking-tight">Join as a RESQLY Ranger</h1>
            <p className="mt-2 text-sm text-blue-100/90 max-w-xs leading-relaxed">
              Be there when someone needs care.
            </p>
            <p className="mt-3 text-xs text-blue-100/75 max-w-sm leading-relaxed">
              For doctors, nurses, caregivers, ambulance partners and other verified service providers.
            </p>
          </div>
        </div>

        <div className="flex-1 px-6 pb-8 -mt-3">
          <div className="resqly-card auth-form-card p-5 shadow-[var(--resqly-shadow-lg)]">
            {children}
          </div>
          {footer}
          <p className="auth-tagline mt-6 text-center text-xs font-medium tracking-wide text-slate-400">
            Healthcare simplified.
          </p>
          <p className="mt-4 text-center text-xs text-slate-500">
            Need healthcare for yourself?{' '}
            <Link to="/consumer/login" className="text-blue-700 font-medium">
              Continue as Customer
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
